import SFullPage from './style.module.scss';
import FadeIn from '../../commonComponents/fadeIn';
import { src } from '../../../utils/common';
import { useRef, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useUserAgentInfo } from '../../../context/user-agent';
import { ButtonGroup } from '../../commonComponents/fullPageBanner';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';

// PC端文字的位置
declare type Position = 'top' | 'left' | 'right' | 'left-top';
// 移动端 文字对齐方式
declare type MobilePosition = 'left' | 'center';

const FullPageSection = ({
  data,
  position = 'top',
  mobilePosition = 'center',
  color = '#fff',
  scale = 1.2,
  buttonConfig,
  transform = true,
}: {
  data: any;
  position?: Position;
  mobilePosition?: MobilePosition;
  color?: string;
  scale?: number;
  buttonConfig?: {
    buttonText: string;
    linkText: string;
    businessLink: string;
    experienceLink: string;
  };
  transform?: boolean;
}) => {
  const ref = useRef(null);
  const { isMobile } = useUserAgentInfo();
  const webPResourceHandleFn = useWebPResourceCompatibleFn();
  useEffect(() => {
    if (transform) {
      const dom = ref.current;
      const viewHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const onScroll = throttle(() => {
        const upper = dom.getBoundingClientRect().top;
        if (upper < viewHeight && upper > -viewHeight) {
          if (upper < viewHeight - 200 && upper > 0) {
            dom.style.transform = `scale(${
              1 +
              ((scale - 1) * (viewHeight - upper - 200)) / (viewHeight - 200)
            })`;
          }
        }
      }, 50);
      window.addEventListener('scroll', onScroll);
      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
  }, []);
  return (
    <>
      <div
        className={`${SFullPage['section']} ${
          SFullPage[isMobile ? mobilePosition : position]
        }`}
        style={{ color }}
      >
        <div className={SFullPage['content']}>
          <FadeIn>
            <div className={SFullPage['title']}>{data.title}</div>
            {/* FadeIn 会覆盖子元素的opacity属性 */}
            <div style={{ opacity: '0.6' }}>
              <div className={SFullPage['desc']}>{data.desc}</div>
            </div>
          </FadeIn>
        </div>
        <div
          className={SFullPage['background']}
          style={{
            backgroundImage: `url('${webPResourceHandleFn(
              src(isMobile ? `${data.picUrlMobile}` : data.picUrl)
            )}')`,
          }}
          ref={ref}
        />
      </div>
      {buttonConfig && isMobile && <ButtonGroup data={buttonConfig} />}
    </>
  );
};

export default FullPageSection;
